import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import services from 'services';
import selectors from 'state/selectors';
import utils from 'utils';

import Header from 'components/Modal/Header';
import { useAsync } from 'react-use';
import { SuppliersIbanList } from 'models/response';
import Table, { TableColumn } from 'components/Table';

const SupplierIbanList = () => {
  const t = utils.intl.useTranslator();
  const [supplierIbanList, setSupplierIbanList] = useState<SuppliersIbanList[]>([]);
  const modalProps = useSelector(selectors.modal.getModalProps);

  const getSupplierIbanList = async () => {
    try {
      const { supplierCode, idCompany } = modalProps;
      if (supplierCode && idCompany !== null) {
        const { data } = await services.getOSuppliersIbanList({ idCompany, supplierCode });
        setSupplierIbanList(data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useAsync(async () => {
    getSupplierIbanList();
  }, [modalProps]);

  const colums: TableColumn[] = [
    {
      accessor: 'sapFamily',
      Header: t('sapFamily'),
    },
    {
      accessor: 'supplierCode',
      Header: t('supplierCode'),
    },
    {
      accessor: 'iban',
      Header: t('iban'),
    },
    {
      accessor: 'bvtyp',
      Header: t('bvtyp'),
    },
    {
      accessor: 'bankn',
      Header: t('bankn'),
    },
    {
      accessor: 'bankl',
      Header: t('bankl'),
    },
  ];

  return (
    <>
      <Header title={t('supplier-iban-list-title')} />
      <Table
        id="supplier-iban-list-table"
        columns={colums}
        rows={supplierIbanList}
        hasToolbar
        hasPagination
        hasResize
        hasSort
        hasFilter
      />
    </>
  );
};

export default SupplierIbanList;
